import type { WhoopStatus } from '@repo/types';

// Mirrors auth/api.ts: same-origin fetches with the session cookie included.

/** Current WHOOP connection state for the signed-in user. */
export async function getWhoopStatus(): Promise<WhoopStatus> {
  const res = await fetch('/api/whoop/status', { credentials: 'include' });
  if (!res.ok) throw new Error(`/api/whoop/status responded ${res.status}`);
  return res.json();
}

/**
 * URL that begins the OAuth link. Navigated to as a top-level GET (not fetched)
 * so the browser follows the 302 to WHOOP's consent screen and the session +
 * state cookies ride along.
 */
export const WHOOP_CONNECT_URL = '/api/whoop/connect';

/** Disconnect WHOOP (revokes tokens server-side; historical data is retained). */
export async function disconnectWhoop(): Promise<void> {
  const res = await fetch('/api/whoop/disconnect', { method: 'POST', credentials: 'include' });
  // Unlike signOut, the caller shows "disconnected" on success — so a server
  // failure must throw rather than let the UI report a disconnect that didn't happen.
  if (!res.ok) throw new Error(`/api/whoop/disconnect responded ${res.status}`);
}
